// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import uuidv4 from 'uuid/v4';

import styles from './styles.js';

class Select extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    options: PropTypes.array,
    onChange: PropTypes.func,
    label: PropTypes.string,
    fixedWidth: PropTypes.bool,
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
  };

  static defaultProps = {
    classes: {},
    options: ['no options'],
    onChange: () => { },
    label: null,
    fixedWidth: false,
    value: null,
  };

  onChangeSelect = (e) => {
    const { name } = this.props;
    this.props.onChange(e.target.value, name);
  }

  render() {
    const {
      classes,
      options,
      label,
      fixedWidth,
      name,
      value,
    } = this.props;


    return (
      <label className={classes.label} htmlFor={`select-${name}`}>
        {label || ''}
        <select
          className={classNames('form-control', classes.select,
            fixedWidth ? classes.fixedWidth : classes.width)}
          onChange={this.onChangeSelect}
          id={`select-${name}`}
          value={value || ''}
        >
          {options.map(el => <option value={el.value} key={uuidv4()}>{el.name}</option>)}
        </select>
      </label>
    );
  }
}

export default withStyles(styles)(Select);
